import React from "react";
import { useParams } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import { useQuery } from "react-query";
import JobDetailsDescription from "./JobDetailsDescription";
import JobVacancyPost from "./JobVacancyPost";
import RightSideContent from "./RightSideContent";
import Section from "./Section";
import { getVacancyById } from "../../../services/vacancyService";
import { useLanguage } from "../../../context/LanguageContext";

const JobDetails = () => {
  const { language } = useLanguage();
  document.title = language === "pt" ? "Detalhes da Vaga" : "Job Details";
  const { id } = useParams();

  const {
    data: job,
    isLoading,
    isError
  } = useQuery({
    queryKey: ["jobDetails", id],
    queryFn: () => getVacancyById(id),
    staleTime: 60 * 1000,
    retry: 1,
  });

  if (isLoading) {
    return (
      <section className="section">
        <Section />
        <Container>
          <div className="text-center py-5">
            <div
              className="spinner-grow text-primary"
              style={{ width: "3rem", height: "3rem" }}
              role="status"
            >
              <span className="visually-hidden">{language === "pt" ? "Carregando..." : "Loading..."}</span>
            </div>
            <p className="mt-3">{language === "pt" ? "Carregando detalhes da vaga..." : "Loading vacancy details..."}</p>
          </div>
        </Container>
      </section>
    );
  }

  if (isError) {
    return (
      <>
        <Section />
        <section className="section">
          <Container>
            <div className="text-center py-5 text-danger">
              {language === "pt" ? "Erro ao carregar detalhes da vaga." : "Failed to fetch job details."}
            </div>
          </Container>
        </section>
      </>
    );
  }

  return (
    <React.Fragment>
      <Section />
      <section className="section">
        <Container>
          <Row>
            <Col lg={8}>
              <JobDetailsDescription job={job} />
              <JobVacancyPost jobId={job.id} />
            </Col>
            <Col lg={4} className="mt-4 mt-lg-0">
              <RightSideContent job={job} />
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default JobDetails;
